<div class="page_title">
    <div class="container-fluid">
        <div class="row">
            <div class="col-auto" *ngIf="this.claimId">
                <k-button [type]="KButtonType.KLAiMSButton" [label]="'Back'" [color]="'brand-main'"
                [icon]="{type: 'kennedys', name: 'back-arrow'}" (buttonClick)="goToPage()">
                </k-button>
            </div>
            <div class="col">
                <h3>Progression Chart</h3>
                <app-custom-breadcrumb *ngIf="customData" [data]="customData"></app-custom-breadcrumb>
            </div>
        </div>
    </div>
</div>

<div class="container-fluid">
    <div class="pages_space">
        <div class="row">
            <div class="col-12 col-md-3 col-lg-2 mb-4">
                <div class="card_claimInfo_wrap">
                    <div class="row">
                        <div class="col-12" style="margin-top: 5px;">
                          <k-card [card]="claimInfo" *ngIf="claimData.length !=0"></k-card>
                        </div>
                      </div>
            
                      <div class="row">
                        <div class="col-12" style="margin-top: 5px;">
                          <k-card [card]="claimInfo2" *ngIf="claimData.length !=0"></k-card>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-12" style="margin-top: 5px;"> 
                            <button type="button" class="klaim_btn btn-brand-main btn-block text-center w-100 mt-2"
                            (click)="viewChartValues()">
                            Chart Values
                          </button>
                        </div>
                      </div>
                </div>
            </div>
            <div class="col-12 col-md-9 col-lg-10">
              <app-asbestos-radiological-progression-chart [claimId]="this.claimId" [radProgId]="this.radProgId"></app-asbestos-radiological-progression-chart>
            </div>
        </div>
    </div>
</div>




